<template>
  <v-dialog
    v-model="value"
    persistent
    max-width="290"
  >
    <v-card>
      <v-card-title class="headline">
        {{ $t('PROFILE.AVATAR.EDIT') }}
      </v-card-title>
      <v-card-text>
        <p>
          {{ $t('PROFILE.AVATAR.DESCRIPTION') }}
        </p>
      </v-card-text>
      <v-card-text>
        <PicSelector ref="selector" />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="darken-1"
          text
          @click="close"
        >
          {{ $t('PROFILE.AVATAR.CANCEL') }}
        </v-btn>
        <v-btn
          v-if="!loading"
          color="primary"
          text
          @click="access"
          :disabled="loading"
        >
          {{ $t('PROFILE.AVATAR.SAVE') }}
        </v-btn>
        <BaseLoader v-else />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PicSelector from '@/components/profile/PicSelector.vue';

export default {
  name: 'EditPicModal',
  components: {
    PicSelector,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    code: '',
    tab: 0,
  }),
  computed: {
    loading() {
      return this.$store.state.settings.isLoading;
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
    access() {
      const face = this.$refs.selector.selectedFace || 2;
      const color = this.$refs.selector.selectedColor || 0;
      const avatar = `${face}_${color}`;
      this.$store.dispatch('settings/store', { pic: avatar })
        .then(() => {
          this.$emit('edit', avatar);
          this.$emit('input', false);
        });
    },
  },
};
</script>
